import React from 'react'
import { Route, IndexRoute } from 'react-router'
import BasePage from './components/BasePage'
import IndexPage from './containers/IndexPage'
import NotFoundPage from './components/NotFoundPage'
import ProjectPage from './components/ProjectPage'
import ImprintPage from './components/ImprintPage'
import ContactPage from './components/ContactPage'
import DSGVOPage from './components/DSGVOPage'
import RatePage from '../rating/containers/RatePage'
import getPath from '../../shared/utils/getPath'

const routes = (
  <Route
    component={BasePage}
    key="base-routes"
    path={getPath('frontend')}
  >
    <IndexRoute component={IndexPage} />
    <Route
      component={ProjectPage}
      path={getPath('frontend', 'project')}
    />
    <Route
      component={DSGVOPage}
      path={getPath('frontend', 'DSGVO')}
    />
    <Route
      component={ImprintPage}
      path={getPath('frontend', 'impressum')}
    />
    <Route
      component={ContactPage}
      path={getPath('frontend', 'contact')}
    />
    <Route
      component={RatePage}
      path={getPath('frontend', 'like/:cryptoId')}
    />
    <Route
      component={RatePage}
      path={getPath('frontend', 'like/:cryptoId/:type')}
    />
    <Route
      component={NotFoundPage}
      path="*"
    />
  </Route>
)

export default routes



// WEBPACK FOOTER //
// ./src/frontend/base/routes.js